import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../../common/types';
import { lyricPanelMessages } from './lyricPanelMessages';
import type { LyricPanelMode } from './useLyricPick';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the lyric panel; each part uses its own slice of it */
import styles from './LyricLinePanel.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface LyricPanelHeaderProps {
  lineCount: number;
  /** Null: no "1 line / 2 lines" switch (no lyrics). */
  mode: LyricPanelMode | null;
  onMode: (mode: LyricPanelMode) => void;
}

const MODES: ReadonlyArray<LyricPanelMode> = ['one', 'two'];

/** The head of the panel: the title, the number of lines and the "1 line / 2 lines" switch. */
const LyricPanelHeaderComponent: React.FC<LyricPanelHeaderProps> = ({ lineCount, mode, onMode }) => {
  const intl = useIntl();
  return (
    <div className={styles.head}>
      <div className={styles.headText}>
        <b className={styles.headTitle}>{intl.formatMessage(lyricPanelMessages.title)}</b>
        {lineCount > 0 && (
          <small className={styles.headSub}>
            {intl.formatMessage(lyricPanelMessages.lineCount, { count: lineCount })}
          </small>
        )}
      </div>
      {mode !== null && (
        <div className={styles.modes} role="radiogroup" aria-label={intl.formatMessage(lyricPanelMessages.modes)}>
          {MODES.map((item) => (
            <button
              key={item}
              type="button"
              role="radio"
              aria-checked={item === mode}
              className={item === mode ? `${styles.mode} ${styles.modeOn}` : styles.mode}
              onClick={() => onMode(item)}
            >
              {intl.formatMessage(item === 'one' ? lyricPanelMessages.oneLine : lyricPanelMessages.twoLines)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export const LyricPanelHeader = TypedMemo(LyricPanelHeaderComponent);
